module.exports = __webpack_public_path__ + "static/media/information.8183165d.svg";